<template>
  <div class="container-flex fill-flex-full">
    <global-error v-if="globalError" />
    <div v-else class="container-right container-flex fill-flex-full">
      <div class="container-flex fill-flex-full">
        <div
          class="main container-flex fill-flex-full"
          v-if="client && client.billing"
        >
          <div class="container-fluid container-flex fill-flex-full bg-white">
            <div class="spacer-75"></div>

            <div class="spacer-40"></div>
            <div class="row px-dynamic">
              <form id="feedback_form" @submit.prevent="submitFeedback">
                <div class="row py-2">
                  <div class="col-12">
                    <h1>Обратная связь</h1>
                  </div>
                </div>

                <div class="row">
                  <div class="col-10">
                    <div class="h3-rem pb-4">
                      Если у Вас есть какие-либо замечания или предложения по
                      улучшению работы приложения, то Вы можете отправить нам
                      сообщение через эту форму.
                    </div>
                  </div>
                </div>

                <div class="row py-2">
                  <div class="col-md-10">
                    <div class="form-group row">
                      <textarea
                        class="form-control input-text"
                        id="feedback-message"
                        rows="6"
                        placeholder="Сообщение"
                        v-model="feedbackMessage"
                        required
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-md-10">
                    <div class="form-group row">
                      <button
                        class="btn btn-blue"
                        id="feedback_button"
                        type="submit"
                        :disabled="isLoadingFeedback"
                      >
                        Отправить
                      </button>
                    </div>
                  </div>
                </div>
              </form>

              <div
                v-show="message"
                class="mt-3"
                :class="{
                  green: feedbackSuccess,
                  warning: !feedbackSuccess,
                }"
              >
                {{ message }}
              </div>

              <!-- <div class="row">
                <div class="col-12 py-2">
                  Нажимая кнопку «Подтвердить», Вы соглашаетесь на обработку
                  <a href="/static/docs/politics.pdf" target="_blank"
                    >персональных данных</a
                  >.
                </div>
              </div> -->

              <div class="spacer-40"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script defer>
import { mapActions, mapGetters, mapState } from "vuex";
import GlobalError from "./GlobalError.vue";

export default {
  components: {
    GlobalError,
  },
  data() {
    return {
      feedbackMessage: "",
      message: null,
    };
  },
  computed: {
    ...mapGetters(["client"]),
    ...mapState([
      "feedbackSuccess",
      "feedbackError",
      "isLoadingFeedback",
      "globalError",
    ]),
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    ...mapActions(["fetchClient", "sendFeedback"]),

    submitFeedback() {
      let message = this.feedbackMessage.trim();
      if (!message) {
        this.message = "Сообщение не может быть пустым";
        return;
      }
      if (message.length > 1000) {
        this.message = "Слишком длинное сообщение. Допустимо до 1000 символов";
        return;
      }

      this.message = null;
      this.sendFeedback({
        clnum: this.client.clientGroup[0].clientId,
        message: message,
      }).then(() => {
        if (this.feedbackSuccess) {
          this.message = "Сообщение успешно отправлено. Спасибо за Ваш отзыв!";
        } else {
          this.message =
            this.feedbackError || "Ошибка отправки сообщения, попробуйте позже";
        }
        this.feedbackMessage = "";
      });
    },
  },
  created() {
    if (this.client === null) {
      this.fetchClient();
    }
  },
};
</script>
